const SET_DROPDOWN_OPEN = 'artful-client/HandwritingUi/SET_DROPDOWN_OPEN';

const initialState = {
  dropdownOpen: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_DROPDOWN_OPEN:
      return {
        ...state,
        dropdownOpen: action.open,
      };
    default:
      return state;
  }
}

export const setDropdownOpen = open => dispatch => {
  dispatch({ type: SET_DROPDOWN_OPEN, open });
};
